module.exports = __webpack_public_path__ + "img/money.cd552b39.png";